import React, { useState, useEffect } from 'react';
import './style.css';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import http from '../../services/http-service';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AccountDetails from './account-details';
import StatementSummery from './statement-summery';
import DisbursementsDetail from './Disbursements-detail';
import { userStatusCommunicationService } from '../../services/communication-service';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function UserDetails(props) {
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(0);
    const [payload, setPayload] = useState(false)
    const [payloadMsg, setPayloadMsg] = useState('')
    const [availableBalace, setAvailableBalace] = useState({})
    const [employeeData, setEmployeeData] = useState({});
    const [employeeProfile, setEmployeeProfile] = useState({})
    const [employeeStatus, setEmployeeStatus] = useState('')
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const goBack = () => {
        history.goBack()
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const fetchUserDetails = () => {
        handleToggle()
        http('admin/employee/?user__id=' + props.match.params.id, 'GET', '')
            .then(res => {
                if (res.status) {
                    setEmployeeData(res.data.results[0] ? res.data.results[0] : []);
                    setEmployeeProfile(res.data.results[0].profile ? res.data.results[0].profile : {})
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId1"
                    })
                }

                handleClose()
            },
                err => {
                    console.log('err....', err)
                    handleClose()
                });
    }

    const getAvailableBalance = () => {
        handleToggle()
        http('employee/user_avaible_balance_on_dashboard/', 'GET', '', { user_id: props.match.params.id })
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    setPayload(res.payload);
                    if (res.payload)
                        setAvailableBalace(res.data);
                    else
                        setPayloadMsg(res.message)
                    fetchUserDetails();
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId2"
                    })
                    handleClose()
                }
            },
                err => {
                    console.log('err....', err)
                    handleClose()
                });
    }

    useEffect(() => {
        getAvailableBalance();
        const userStatus = userStatusCommunicationService.getUserStatus().subscribe(status => {
            console.log(status.statusValue, 'statusbymukul');
            setEmployeeStatus(status.statusValue)
          });
        // eslint-disable-next-line
    }, []);

    return (
        <div className='commonPageDiv'>
            <ToastContainer />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className='samulels'>
                <Grid container className='MainBackBtn'>
                    <Grid item xs={1} className='BackIcon'>
                        <ArrowBackIcon onClick={goBack} style={{ cursor: 'pointer' }} />
                    </Grid>
                    <Grid item xs={11} md={11} className='Grid10Status'>
                        <Typography gutterBottom component="div" className='typoStatus'>
                            Status: <Typography className='typoStatusPending'> {employeeStatus ? employeeStatus : employeeProfile.status ? employeeProfile.status : ''}</Typography>
                        </Typography>
                        <Typography gutterBottom component="div" className='SamuelTypo'>
                            {employeeData.first_name} {employeeData.last_name}
                            <Typography gutterBottom component="div" className='AVAILABLETypo'>
                                AVAILABLE BALANCE: ₦{payload ? availableBalace.balance : payloadMsg}
                            </Typography>
                        </Typography>
                    </Grid>
                </Grid>

            </div>
            <div className='mainTabDiv'>
                <Box sx={{ width: '100%' }} className='userDetailBox'>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Account Details" {...a11yProps(0)} className="textTransformDefault" />
                            <Tab label="Statements" {...a11yProps(1)} className="textTransformDefault" />
                            <Tab label="Disbursements" {...a11yProps(2)} className="textTransformDefault" />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0} className="userPanel">
                        {Object.keys(employeeData).length > 0 ? <AccountDetails employeeData={employeeData} userId={props.match.params.id} /> : ""}

                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Grid>
                            {Object.keys(employeeData).length > 0 ? <StatementSummery employeeData={employeeData} userId={props.match.params.id} /> : ""}
                        </Grid>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <Grid>
                            {Object.keys(employeeData).length > 0 ? <DisbursementsDetail employeeData={employeeData} userId={props.match.params.id} /> : ""}
                        </Grid>
                    </TabPanel>
                </Box>
            </div>
        </div>

    )
}





export default UserDetails;